import type { RegisteredColumnId } from "./RegisteredColumnId";

type Translator = (key: string, vars?: Record<string, string | number>) => string;

// Maps each column id to its translation key in en.ts / de.ts.
// Column display labels are derived from this mapping so both the table
// header and the "Choose columns" settings modal translate consistently.
const COLUMN_KEY: Record<string, string> = {
  IMAGE: "column.image",
  NAME: "column.name",

  UNITS: "column.units",
  BUILDINGS: "column.buildings",
  MODULES: "column.modules",
  FLOORS: "column.floors",
  FLOORSRESIDENTIAL: "column.floorsResidential",
  PODIUMLEVELS: "column.podiumLevels",
  CORES: "column.cores",
  LIFTCORES: "column.liftCores",
  FIREFIGHTINGCORES: "column.firefightingCores",
  ENTRANCES: "column.entrances",
  UNITSPERCORE: "column.unitsPerCore",
  DUALASPECT: "column.dualAspectUnits",
  PARTMCOMPLIANTUNIT: "column.partMCompliantUnits",

  BUILDINGHEIGHT: "design.buildingHeight",
  FFL: "design.ffl",
  GEA: "metrics.gea",
  GIA: "design.gia",
  NIA: "design.nia",
  BUILDINGFOOTPRINT: "design.buildingFootprint",
  COMMERCIALAREA: "design.commercialArea",
  NONRESIDENTIALAREA: "column.nonResidentialArea",
  COREANDCORRIDOR: "column.coreAndCorridorArea",
  SERVICEAREA: "column.serviceArea",
  AMENITIESAREA: "design.amenitiesArea",
  GROSSFACADEAREA: "design.grossFacadeArea",
  GLAZEDFACADEAREA: "column.glazedFacadeArea",
  NETFACADEAREA: "column.netFacadeArea",
  ROOFAREA: "column.roofArea",
  CONCAVEFACADECORNER: "column.concaveFacadeCorner",
  CONVEXFACADECORNER: "column.convexFacadeCorner",

  DENSITY: "column.density",
  DENSITY_HABITABLEROOMS: "column.densityHabitableRooms",
  RESIDENTIALEFFICIENCY: "design.residentialEfficiency",
  BUILDINGEFFICIENCY: "design.buildingEfficiency",
  LANDCOVERAGE: "design.landCoverage",
  UNITMIX: "metrics.unitMix",
  WALLTOFLOORRATIO: "column.wallToFloorRatio",
  NORTHFACINGUNITS: "design.northFacingUnits",

  MODULESCOST: "column.modules",
  CONSTRUCTIONCOST: "explore.constructionCost",
  FITOUT: "costMetrics.fitOut",
  BASEBUILD: "costMetrics.baseBuild",
  PRELIMS: "costSummary.prelims",
  TOTALCOST: "explore.totalCost",
  CONTINGENCY: "costSummary.contingency",
  OHAPALLOWANCE: "costSummary.ohp",
  CONSTRUCTIONSQFT: "costMetrics.constructionPerArea",
  CONSTRUCTIONUNIT: "costMetrics.constructionPerUnit",

  INDICATIVEFORMFACTOR: "sustainability.indicativeFormFactor",
  CO2FOOTPRINT: "sustainability.co2Footprint",
  CO2FOOTPRINTSQFT: "sustainability.co2FootprintPerArea",
  SUBSTRUCTURECO2FOOTPRINT: "sustainability.substructureCo2PerArea",
  SUBSTRUCTURECO2FOOTPRINT2: "sustainability.substructureCo2",
  SUPERSTRUCTURECO2FOOTPRINT: "sustainability.superstructureCo2PerArea",
  SUPERSTRUCTURECO2FOOTPRINT2: "sustainability.superstructureCo2",
  STEELCO2FOOTPRINT: "sustainability.steelCo2PerArea",
  STEELCO2FOOTPRINT2: "sustainability.steelCo2",
  CONCRETECO2FOOTPRINT: "sustainability.concreteCo2PerArea",
  CONCRETECO2FOOTPRINT2: "sustainability.concreteCo2",
};

export function columnLabel(id: RegisteredColumnId, fallback: string, t: Translator): string {
  const key = COLUMN_KEY[id];
  return key ? t(key) : fallback;
}

export { COLUMN_KEY };
